exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":host {\r\n  position: fixed !important;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background: #1d252d;\r\n}", ""]);

